import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog/dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table/table";
import { formatDuration } from "@/components/break/format";
import type { BreakView } from "@/components/break/types";
import { formatDateToIST, formatTimeToIST } from "@/utils/timezone";

import { useEmpBreaksModal } from "./use-breaks-modal";

function endedBy(b: BreakView): string {
  if (b.open) return "In progress";
  if (b.closedBy === "checkout") return "Check-out";
  if (b.closedBy === "checkin") return "Next check-in";
  return "Employee";
}

export const EmployeeBreaksModal = ({ breaks }: { breaks: BreakView[] }) => {
  const { open, onOpenChange } = useEmpBreaksModal();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-4xl overflow-y-auto max-h-[580px]"
        data-testid="emp-breaks-modal"
      >
        <DialogHeader>
          <DialogTitle>Employee Breaks (last 30 days)</DialogTitle>
        </DialogHeader>

        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Started</TableHead>
              <TableHead>Ended</TableHead>
              <TableHead>Duration</TableHead>
              <TableHead>Reason</TableHead>
              <TableHead>Ended by</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {breaks.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} className="text-center text-muted-foreground">
                  No breaks recorded.
                </TableCell>
              </TableRow>
            )}
            {breaks.map((b) => (
              <TableRow key={b._id} data-testid="emp-break-row">
                <TableCell>{formatDateToIST(b.startedAt)}</TableCell>
                <TableCell>{formatTimeToIST(b.startedAt)}</TableCell>
                <TableCell>{b.endedAt ? formatTimeToIST(b.endedAt) : "—"}</TableCell>
                <TableCell>{formatDuration(b.durationSeconds)}</TableCell>
                <TableCell>{b.reason || "—"}</TableCell>
                <TableCell>{endedBy(b)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};
